// eslint-disable-next-line import/prefer-default-export
export const YOUTUBE_COLOR = '#FF0000';

export function getYoutubeConfig() {
  return {
    color: YOUTUBE_COLOR,
  };
}
